class pdpInfoCard extends HTMLElement {
  constructor() {
    super()
    this.modal = this
    this.modalCard = this.querySelector('[data-pdp-info-modal-card]')
    this.modalContent = this.querySelector('[data-modal-content]')
    this.modalImage = this.querySelector('[data-modal-image]')
    this.modal_bg = this.querySelector('[data-pdp-info-modal-bg]')
    this.modal_close_button = this.querySelector('[data-modal-close-button]')
    this.modal_open_buttons = document.querySelectorAll('[data-pdp-info-modal-open]')
    this.event_target = ''


    this.init()
  }

  openModal = () => {
    this.modal.classList.add('!visible', '!opacity-100')
    this.modalCard.classList.add('!translate-y-0')

    setTimeout(() => {
      trapFocus(this.modalCard, this.modal_close_button)
    }, 300);
  }

  closeModal = () => {
    this.modalCard.classList.remove('!translate-y-0')
    this.modal.classList.remove('!visible', '!opacity-100')
    removeTrapFocus()
    this.event_target.focus()
  }

  init() {
    this.modal_close_button.addEventListener('click', () => {
      this.closeModal()
    })

    this.modal_bg.addEventListener('click', () => {
      this.closeModal()
    })

    this.modal_open_buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        if (button.dataset.modalImage) {
          this.modalImage.classList.add('opacity-0')
          if (button.dataset.modalImageFullWidth === 'true') {
            this.modalImage.classList.remove('max-w-[220px]', 'max-h-[140px]')
            this.modalImage.parentElement.classList.remove('py-10', 'max-lg:py-5')
          } else {
            this.modalImage.classList.add('max-w-[220px]', 'max-h-[140px]')
            this.modalImage.parentElement.classList.add('py-10', 'max-lg:py-5')
          }
          this.modalImage.src = button.dataset.modalImage
          this.modalImage.width = button.dataset.modalImageWidth
          this.modalImage.height = button.dataset.modalImageHeight
          this.modalImage.parentElement.classList.remove('!hidden')
        } else this.modalImage.parentElement.classList.add('!hidden')

        if (button.dataset.modalContent) this.modalContent.innerHTML = atob(button.dataset.modalContent)

        this.openModal()
        this.event_target = event.target
      })
    })


  }
}
customElements.define('pdp-info-card', pdpInfoCard)